// extracted by mini-css-extract-plugin
export default {"section":"editUserData_section__cNge9","btn":"editUserData_btn__Ktd6i"};